import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_page = _resolveComponent("page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.table,
        stripe: "",
        "empty-text": "没有记录",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            type: "index",
            label: "序号",
            width: "50"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "executeName",
            label: "被执行人名称"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "equityAmount",
            label: "股权数额"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "executeCourt",
            label: "执行法院"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "executionNoticeNum",
            label: "通知文书号"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "status",
            label: "类型 | 状态"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "relatedInfo",
            label: "冻结股权标的企业信息"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.relatedInfo?scope.row.relatedInfo.name:'-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.ckInfo(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_page, {
      currentPage: _ctx.pageIndex,
      pageSize: _ctx.pageSize,
      pages: _ctx.pageCount,
      onChangePage: _ctx.changePage
    }, null, 8, ["currentPage", "pageSize", "pages", "onChangePage"])
  ], 64))
}